export default __webpack_public_path__ + "static/media/Comerciales.e8f5e03e.svg";